import { createApi } from '@reduxjs/toolkit/query/react';
import { setDomainCatalog } from '@app/shared/utils/domainDisplay.utils';
import { createSentryFetchBaseQuery } from './sentryFetchBaseQuery';
import type { DomainsResponse } from '@shared/types/domain.types';

export const domainsApi = createApi({
  reducerPath: 'domainsApi',
  baseQuery: createSentryFetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_BASE_URL}/project/`
  }),
  endpoints: builder => ({
    getDomains: builder.query<DomainsResponse, void>({
      query: () => 'utils/domains',
      transformResponse: (response: DomainsResponse) => {
        if (response?.domains?.length) {
          setDomainCatalog(response.domains);
        }
        return response;
      }
    })
  })
});

export const { useGetDomainsQuery } = domainsApi;
